import type { FC, ReactNode } from 'react'

interface PageHeaderProps {
    title: string
    description?: ReactNode
    actions?: ReactNode
}

export const PageHeader: FC<PageHeaderProps> = ({ title, description, actions }): ReactNode => {
    return (
        <div className='mb-6 flex flex-col gap-4 lg:mb-8 lg:flex-row lg:items-end lg:justify-between'>
            <div className='min-w-0'>
                <h1 className='font-heading text-2xl font-bold tracking-tight text-foreground sm:text-3xl'>
                    {title}
                </h1>

                {description && (
                    <p className='mt-1.5 text-sm text-muted-foreground'>
                        {description}
                    </p>
                )}
            </div>

            {actions && (
                <div className='flex flex-wrap items-center gap-2'>
                    {actions}
                </div>
            )}
        </div>
    )
}
